const defaultWallpaper = [
    {
        id: 'DEFAULT',
        name: 'Standaard',
        path: '/static/img/wallpapers/default.jpg'
    }
];

const WALLPAPERS = [
    ...defaultWallpaper,
    {
        id: 'AURORA',
        name: 'Noorderlicht',
        path: '/static/img/wallpapers/aurora.jpg'
    },
    {
        id: 'BEER',
        name: 'Bier',
        path: '/static/img/wallpapers/beer.jpg'
    },

    {
        id: 'FINANCIAL_FREEDOM',
        name: 'Financiële vrijheid',
        path: '/static/img/wallpapers/financial-freedom.jpg'
    },
    {
        id: 'FORD_MUSTANG_SHELBY',
        name: 'Ford Mustang Shelby',
        path: '/static/img/wallpapers/ford-mustang-shelby.jpg'
    },
    {
        id: 'GAME_ROOM_1',
        name: 'Game kamer 1',
        path: '/static/img/wallpapers/game-room-1.jpg'
    },
    {
        id: 'GAME_ROOM_2',
        name: 'Game kamer 2',
        path: '/static/img/wallpapers/game-room-2.jpg'
    },
    {
        id: 'GAME_SETUP',
        name: 'Gaming setup',
        path: '/static/img/wallpapers/game-setup.jpg'
    },
    {
        id: 'GUITAR',
        name: 'Gitaar',
        path: '/static/img/wallpapers/guitar.jpg'
    },
    {
        id: 'JACUZZI',
        name: 'Jacuzzi',
        path: '/static/img/wallpapers/jacuzzi.jpg'
    },
    {
        id: 'OPERA_HOUSE',
        name: 'Opera House Sydney',
        path: '/static/img/wallpapers/opera-house.jpg'
    },
    {
        id: 'PORCHE',
        name: 'Porche',
        path: '/static/img/wallpapers/porche.jpg'
    },
    {
        id: 'RENOVATION',
        name: 'Verbouwing',
        path: '/static/img/wallpapers/renovation.jpg'
    },
    {
        id: 'TRAVEL_1',
        name: 'Droomreis 1',
        path: '/static/img/wallpapers/travel-1.jpg'
    },
    {
        id: 'TRAVEL_2',
        name: 'Droomreis 1',
        path: '/static/img/wallpapers/travel-2.jpg'
    },
    {
        id: 'TREEHOUSE',
        name: 'Boomhuis',
        path: '/static/img/wallpapers/treehouse.jpg'
    },
    {
        id: 'WEDDING',
        name: 'Bruiloft',
        path: '/static/img/wallpapers/wedding.jpg'
    }
];

const storageKey = 'rockstars.mybonus.wallpaper';

export const getWallpaperFromStorage =
    WALLPAPERS.find(({ id }) => {
        const key = localStorage.getItem(storageKey);
        return key === id;
    }) || defaultWallpaper;

export const getWallpaperFromId = (wallpaperId) =>
    WALLPAPERS.find(({ id }) => id === wallpaperId) || defaultWallpaper;

export const setWallpaperInStorage = (wallpaper) => {
    localStorage.setItem(storageKey, wallpaper.id);
};

export default WALLPAPERS;
